import React from "react";

const BlogPostContent = ({ post }) => {
  return (
    <div className="blog-post-content">
      <div className="blog-post-container">
        <div className="blog-post-sidebar">
          <div className="sharing-section">
            <h4 className="sharing-title">Share this article</h4>
            <div className="social-sharing">
              <button className="share-button facebook">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 14.9912 3.65684 19.1283 8.4375 19.8785V12.8906H5.89844V10H8.4375V7.79688C8.4375 5.29063 9.93047 3.90625 12.2146 3.90625C13.3084 3.90625 14.4531 4.10156 14.4531 4.10156V6.5625H13.1922C11.95 6.5625 11.5625 7.3334 11.5625 8.125V10H14.3359L13.8926 12.8906H11.5625V19.8785C16.3432 19.1283 20 14.9912 20 10Z"
                    fill="currentColor"
                  />
                </svg>
              </button>

              <button className="share-button twitter">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M6.29 18.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0020 3.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.073 4.073 0 01.8 7.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 010 16.407a11.616 11.616 0 006.29 1.84"
                    fill="currentColor"
                  />
                </svg>
              </button>

              <button className="share-button linkedin">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M18.5195 0H1.47656C0.660156 0 0 0.644531 0 1.44141V18.5547C0 19.3516 0.660156 20 1.47656 20H18.5195C19.3359 20 20 19.3516 20 18.5586V1.44141C20 0.644531 19.3359 0 18.5195 0ZM5.93359 17.043H2.96484V7.49609H5.93359V17.043ZM4.44922 6.19531C3.49609 6.19531 2.72656 5.42578 2.72656 4.47656C2.72656 3.52734 3.49609 2.75781 4.44922 2.75781C5.39844 2.75781 6.16797 3.52734 6.16797 4.47656C6.16797 5.42188 5.39844 6.19531 4.44922 6.19531ZM17.043 17.043H14.0781V12.4023C14.0781 11.2969 14.0586 9.87109 12.5352 9.87109C10.9922 9.87109 10.7578 11.0781 10.7578 12.3242V17.043H7.79297V7.49609H10.6406V8.80078H10.6797C11.0742 8.05078 12.043 7.25781 13.4844 7.25781C16.4883 7.25781 17.043 9.23438 17.043 11.8047V17.043Z"
                    fill="currentColor"
                  />
                </svg>
              </button>

              <button className="share-button email">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M18 4H2C1.45 4 1 4.45 1 5V15C1 15.55 1.45 16 2 16H18C18.55 16 19 15.55 19 15V5C19 4.45 18.55 4 18 4ZM18 7L10 11L2 7V5L10 9L18 5V7Z"
                    fill="currentColor"
                  />
                </svg>
              </button>
            </div>
          </div>

          <div className="table-of-contents">
            <h4 className="toc-title">Table of Contents</h4>
            <nav className="toc-nav">
              <a href="#freedom" className="toc-link">
                Freedom to Explore at Your Own Pace
              </a>
              <a href="#culture" className="toc-link">
                Immersive Cultural Experiences
              </a>
              <a href="#value" className="toc-link">
                Unbeatable Value for Money
              </a>
              <a href="#sustainable" className="toc-link">
                Sustainable and Eco-Friendly Travel
              </a>
              <a href="#tips" className="toc-link">
                Essential Tips for First-Time Travelers
              </a>
            </nav>
          </div>
        </div>

        <div className="blog-post-article">
          <div
            className="article-content"
            dangerouslySetInnerHTML={{ __html: post.content }}
          />

          <div className="article-tags">
            <span className="tags-label">Tags:</span>
            <div className="tags-list">
              {post.tags.map((tag, index) => (
                <span key={index} className="tag-item">
                  {tag}
                </span>
              ))}
            </div>
          </div>

          <div className="article-sharing">
            <span className="sharing-text">
              Did you find this article helpful?
            </span>
            <div className="sharing-actions">
              <button className="like-button">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M14.828 7.99999C14.828 7.99999 13.621 6.79299 11.328 6.79299C10.914 6.79299 10.517 6.84799 10.138 6.94999V3.99999C10.138 2.34599 8.792 0.999985 7.138 0.999985C6.586 0.999985 6.138 1.44799 6.138 1.99999V8.13799L3.707 10.569C3.317 10.959 3.317 11.592 3.707 11.982L4.414 12.689C4.609 12.884 4.874 12.993 5.15 12.993H12.138C13.242 12.993 14.138 12.097 14.138 10.993V8.99999C14.138 8.44799 14.586 7.99999 14.828 7.99999Z"
                    fill="currentColor"
                  />
                </svg>
                Helpful
              </button>

              <button className="share-article-button">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M13 10C12.5 10 12.05 10.17 11.69 10.45L5.68 7.44C5.89 6.96 5.89 6.04 5.68 5.56L11.69 2.55C12.05 2.83 12.5 3 13 3C14.1 3 15 2.1 15 1C15 -0.1 14.1 -1 13 -1C11.9 -1 11 -0.1 11 1C11 1.26 11.07 1.51 11.18 1.73L5.17 4.74C4.83 4.46 4.42 4.29 4 4.29C2.9 4.29 2 5.19 2 6.29C2 7.39 2.9 8.29 4 8.29C4.42 8.29 4.83 8.12 5.17 7.84L11.18 10.85C11.07 11.07 11 11.32 11 11.58C11 12.68 11.9 13.58 13 13.58C14.1 13.58 15 12.68 15 11.58C15 10.48 14.1 9.58 13 9.58L13 10Z"
                    fill="currentColor"
                  />
                </svg>
                Share Article
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogPostContent;
